const firebase = require("../firebaseConfig.js");

const model = {
  text: null,
  category: null
};

const fields = [
  {
    path: "text",
    type: "text",
    label: "Skill name"
  },
  {
    path: "isParent",
    type: "boolean",
    label: "Is Parent"
  },
  {
    path: "category",
    type: "single_select",
    label: "Category",
    reference: "skills",
    options: firebase.db.collection("skills").where("isParent", "==", true),
    text_field: "text"
  }
];

const tableFields = [
  {
    key: "text",
    label: "Skill",
    sortable: true
  },
  {
    key: "category",
    label: "Category",
    sortable: true,
    formatter: (value, key, item) => {
      return item.isParent === true ? "—" : item.category.text;
    }
  }
];

const info = {
  id: "skills",
  db: "skills",
  name: "Skills",
  single: "Skill",
  fields: tableFields
};

export {model, fields, info};
